export default theme => ({
  buttonsContainer: {
    marginTop: 24,
    display: "flex",
    justifyContent: "center",
  },
  validationErrorContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
});
